export default {
  vehicle_add: ['vehicle_management', 'vehicle_add'],
  vehicle_edit: ['vehicle_edit'],
  vehicle_delete: ['vehicle_delete'],
  vehicle_archive: ['vehicle_archive'],
  vehicle_restore: ['vehicle_restore'],
  vehicle_administration: ['vehicle_administration'],
  vehicle_management: ['vehicle_management'],

  vehicle_document_management: ['vehicle_document_management'],
  vehicle_document_add: ['vehicle_document_add'],
  vehicle_document_edit: ['vehicle_document_edit'],
  vehicle_document_delete: ['vehicle_document_delete'],
  vehicle_document_archive: ['vehicle_document_archive'],
  vehicle_document_restore: ['vehicle_document_restore'],

  vehicle_plugin_management: ['vehicle_plugin_management'],
  vehicle_plugin_add: ['vehicle_plugin_add', 'supply_management'],
  vehicle_plugin_delete: ['vehicle_plugin_delete'],
  vehicle_plugin_archive: ['vehicle_plugin_archive'],
  vehicle_plugin_restore: ['vehicle_plugin_restore'],

  vehicle_insurance_management: ['vehicle_insurance_management'],
  vehicle_insurance_add: ['vehicle_insurance_add'],
  vehicle_insurance_edit: ['vehicle_insurance_edit'],
  vehicle_insurance_delete: ['vehicle_insurance_delete'],

  remooc_edit_pricing: ['remooc_edit_pricing'],
  remooc_management: ['remooc_management'],
  remooc_edit: ['remooc_edit'],
  remooc_archive: ['remooc_archive'],
  remooc_restore: ['remooc_restore'],
  remooc_add: ['remooc_add'],
  remooc_delete: ['remooc_delete'],

  remooc_document_management: ['remooc_document_management'],
  remooc_document_add: ['remooc_document_add'],
  remooc_document_edit: ['remooc_document_edit'],
  remooc_document_delete: ['remooc_document_delete'],
  remooc_document_archive: ['remooc_document_archive'],
  remooc_document_restore: ['remooc_document_restore'],

  remooc_category_management: ['remooc_category_management'],
  remooc_category_edit: ['remooc_category_edit'],
  remooc_category_add: ['remooc_category_add'],
  remooc_category_delete: ['remooc_category_delete'],
  remooc_category_archive: ['remooc_category_archive'],
  remooc_category_restore: ['remooc_category_restore'],

  vehicle_repair_management: ['vehicle_repair_management'],
  vehicle_repair_add: ['vehicle_repair_add'],
  vehicle_repair_edit: ['vehicle_repair_edit'],
  vehicle_repair_delete: ['vehicle_repair_delete'],
  vehicle_repair_archive: ['vehicle_repair_archive']
}
